import type { DetailedHTMLProps, FC, InputHTMLAttributes, Ref } from 'react';
import React from 'react';

import { cnCheckbox } from '../Checkbox.cn';

import './Checkbox-Control.css';

type InputProps = Pick<
    DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
    | 'className'
    | 'onChange'
    | 'disabled'
    | 'name'
    | 'checked'
    | 'readOnly'
    | 'value'
    | 'id'
    | 'onKeyUp'
    | 'onKeyDown'
    | 'tabIndex'
    | 'required'
    | 'autoFocus'
>;

// @analyze-exports:disable
export interface ICheckboxControlProps extends InputProps {
    /**
     * Ссылка на DOM элемент нативного инпута
     */
    controlRef?: Ref<HTMLInputElement>;
}

// @analyze-exports:disable
export const CheckboxControl: FC<ICheckboxControlProps> = ({ controlRef, className, ...props }) => (
    <input
        {...props}
        // Отключаем autoComplete, чтобы в FireFox
        // не сохранялось значение при перезагрузке страницы.
        autoComplete="off"
        className={cnCheckbox('Control', null, [className])}
        ref={controlRef}
        type="checkbox"
    />
);
